// Photographs for the landing page, sign-in and empty states. They are
// AI-generated illustrations (Okiru marketing set 01a10dd4-...), not photos
// of real Okiru staff, clients or learners. WebP, under 200 KB, fixed aspect
// ratios (16:9 landscape, 3:4 portrait); dimensions are given to prevent layout
// shift while they load.

export const IMAGES = {
  groupDiscussion: {
    src: '/images/group-discussion.webp', width: 1600, height: 900,
    alt: 'A facilitator leads a discussion with colleagues seated around a meeting table, with a mountain visible through the windows.',
  },
  facilitatorFlipchart: {
    src: '/images/facilitator-flipchart.webp', width: 1600, height: 900,
    alt: 'A facilitator stands at a flip chart while learners with laptops follow the session.',
  },
  learnerLaptop: {
    src: '/images/learner-laptop.webp', width: 1600, height: 900,
    alt: 'A learner works through an online course on a laptop at a shared office desk.',
  },
  worksheetReview: {
    src: '/images/worksheet-review.webp', width: 1600, height: 900,
    alt: 'Two colleagues go through a printed worksheet together, with a calculator on the desk.',
  },
  teamLaptop: {
    src: '/images/team-laptop.webp', width: 1600, height: 900,
    alt: 'Three colleagues discuss work on a laptop at a shared table.',
  },
  colleaguesCelebrate: {
    src: '/images/colleagues-celebrate.webp', width: 1600, height: 900,
    alt: 'Colleagues congratulate a smiling woman holding a notebook.',
  },
  professionalPortrait: {
    src: '/images/professional-portrait.webp', width: 900, height: 1200,
    alt: 'A professional holding a notebook stands in the doorway of a bright office.',
  },
  solarSiteColleagues: { src: '/images/solar-site-colleagues.webp', width: 1600, height: 900, alt: 'Two colleagues in safety helmets review plans beside solar panels.' },
  colleaguesReviewPlans: { src: '/images/colleagues-review-plans.webp', width: 1600, height: 900, alt: 'Colleagues collaborate over printed plans and a laptop at a desk.' },
  learnerCommute: { src: '/images/learner-commute.webp', width: 900, height: 1200, alt: 'A learner checks a phone while standing on a station platform.' },
  colleaguesDiscussion: { src: '/images/colleagues-discussion.webp', width: 1600, height: 900, alt: 'A group of colleagues discuss a project around a meeting table.' },
  teamReviewingChart: { src: '/images/team-reviewing-chart.webp', width: 1600, height: 900, alt: 'Two colleagues review charts on a screen together.' },
  colleaguesOnlineLearning: { src: '/images/colleagues-online-learning.webp', width: 1600, height: 900, alt: 'Colleagues take part in online learning together at a laptop.' },
  facilitatorTeamSupport: { src: '/images/facilitator-team-support.webp', width: 1600, height: 900, alt: 'A facilitator supports colleagues during a workplace discussion.' },
};
